<template>
  <div class="row sn-header-container">
    <div class="sn-header-title">{{title}}</div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    }
  }
};
</script>

<style lang="scss" scoped>
.sn-header-container {
  justify-content: space-between;
  padding: 0 24px;
  width: 100%;
  height: 44px;
  line-height: 44px;
  background-color: #ffffff;
  box-shadow: inset 0px -1px 0px 0px#f7f7fa;
  .sn-header-title {
    color: #171f46;
    font-size: 14px;
  }
}
</style>

